/**
 * @generated SignedSource<<2519dbf4f984912154dfc507593f3717>>
 * @relayHash fecac1223d0ae7cacb4cff7f7a02672b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3412d565a789fe8ad831df0c4c20783567b02aa6784cb67786107136db6d3b13

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfileCardEntryPointQuery$variables = {
  activityFirst?: number | null;
  cloudId: string;
  collabContextId?: string | null;
  orgId: string;
  siteAri: string;
  skipActivity: boolean;
  skipKnowledgeDiscovery: boolean;
  skipReportingLines: boolean;
  userAri: string;
  userId: string;
  userIdString: string;
  viewerId: string;
};
export type UserProfileCardEntryPointQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileCardRelay_query">;
};
export type UserProfileCardEntryPointQuery = {
  response: UserProfileCardEntryPointQuery$data;
  variables: UserProfileCardEntryPointQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activityFirst"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipActivity"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipKnowledgeDiscovery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipReportingLines"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userAri"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIdString"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewerId"
},
v12 = {
  "kind": "Variable",
  "name": "collabContextId",
  "variableName": "collabContextId"
},
v13 = {
  "kind": "Variable",
  "name": "orgId",
  "variableName": "orgId"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "picture"
},
v17 = {
  "kind": "ScalarField",
  "name": "email"
},
v18 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v19 = {
  "kind": "ScalarField",
  "name": "id"
},
v20 = {
  "kind": "ScalarField",
  "name": "product"
},
v21 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v21/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v21/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v21/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v26 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v21/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/)
    ]
  }
],
v27 = {
  "kind": "ScalarField",
  "name": "url"
},
v28 = [
  (v27/*: any*/)
],
v29 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v30 = [
  (v29/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v29/*: any*/),
      (v19/*: any*/)
    ]
  }
],
v31 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v32 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v33 = [
  (v27/*: any*/),
  (v19/*: any*/)
],
v34 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
],
v35 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      (v16/*: any*/),
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          (v18/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "activityFirst",
            "variableName": "activityFirst"
          },
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "kind": "Variable",
            "name": "siteAri",
            "variableName": "siteAri"
          },
          {
            "kind": "Variable",
            "name": "skipActivity",
            "variableName": "skipActivity"
          },
          {
            "kind": "Variable",
            "name": "skipKnowledgeDiscovery",
            "variableName": "skipKnowledgeDiscovery"
          },
          {
            "kind": "Variable",
            "name": "skipReportingLines",
            "variableName": "skipReportingLines"
          },
          {
            "kind": "Variable",
            "name": "userAri",
            "variableName": "userAri"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          },
          {
            "kind": "Variable",
            "name": "userIdString",
            "variableName": "userIdString"
          },
          {
            "kind": "Variable",
            "name": "viewerId",
            "variableName": "viewerId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "UserProfileCardRelay_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
          }
        ],
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "accountStatus"
          },
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "department"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "location"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "organization"
                  }
                ]
              }
            ],
            "type": "AtlassianAccountUser"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/)
            ],
            "type": "CustomerUser"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appType"
              }
            ],
            "type": "AppUser"
          },
          (v19/*: any*/)
        ]
      },
      {
        "condition": "skipActivity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "actors.0",
                            "variableName": "userAri"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "actors"
                      },
                      (v12/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "activityFirst"
                  }
                ],
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "workedOn",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "ConfluenceDatabaseLinks",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": false,
                                        "selections": (v21/*: any*/)
                                      }
                                    ],
                                    "type": "ConfluenceDatabase"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "ConfluenceEmbedLinks",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": false,
                                        "selections": (v21/*: any*/)
                                      }
                                    ],
                                    "type": "ConfluenceEmbed"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v26/*: any*/),
                                    "type": "ConfluenceFooterComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v26/*: any*/),
                                    "type": "ConfluenceInlineComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "TownsquareGoal"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "TownsquareProject"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "TownsquareComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v29/*: any*/)
                                    ],
                                    "type": "JiraIssue"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v30/*: any*/),
                                    "type": "JiraPlatformComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v30/*: any*/),
                                    "type": "JiraServiceManagementComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v31/*: any*/),
                                    "type": "TrelloBoard"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v31/*: any*/),
                                    "type": "TrelloCard"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v32/*: any*/),
                                    "type": "DevOpsDocument"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "ExternalDocument"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v33/*: any*/),
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "ExternalPullRequest"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v32/*: any*/),
                                    "type": "DevOpsDesign"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "ExternalRemoteLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "MercuryFocusArea"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v33/*: any*/),
                                    "type": "MercuryPortfolio"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "RadarPosition"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "RadarView"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v28/*: any*/),
                                    "type": "CompassComponent"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "href"
                                      }
                                    ],
                                    "type": "BitbucketPullRequest"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": "loomUrl",
                                        "kind": "ScalarField",
                                        "name": "url"
                                      }
                                    ],
                                    "type": "LoomVideo"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v34/*: any*/),
                                    "type": "AssetsObject"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v34/*: any*/),
                                    "type": "AssetsObjectType"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v34/*: any*/),
                                    "type": "AssetsSchema"
                                  },
                                  (v25/*: any*/)
                                ]
                              },
                              (v19/*: any*/)
                            ]
                          },
                          (v19/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skipKnowledgeDiscovery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "userIdString"
                  },
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "requestingUserId",
                    "variableName": "viewerId"
                  },
                  {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "LinkedField",
                "name": "singleUser",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeDiscoveryUserProfile",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "KnowledgeDiscoveryUserManager",
                            "kind": "LinkedField",
                            "name": "manager",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v18/*: any*/),
                              (v16/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                            "kind": "LinkedField",
                            "name": "thirdPartyIntegrations",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "externalId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "integrationId"
                              },
                              (v20/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeDiscoverySingleUser"
                  }
                ]
              },
              {
                "condition": "skipReportingLines",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "aaid",
                        "variableName": "userIdString"
                      },
                      (v13/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "siteId",
                        "variableName": "siteAri"
                      }
                    ],
                    "kind": "LinkedField",
                    "name": "reportingLines",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v35/*: any*/)
                          },
                          {
                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                            "kind": "LinkedField",
                            "name": "managers",
                            "plural": true,
                            "selections": (v35/*: any*/)
                          },
                          {
                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                            "kind": "LinkedField",
                            "name": "reports",
                            "plural": true,
                            "selections": (v35/*: any*/)
                          }
                        ],
                        "type": "KnowledgeDiscoveryReportingLines"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3412d565a789fe8ad831df0c4c20783567b02aa6784cb67786107136db6d3b13",
    "metadata": {},
    "name": "UserProfileCardEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0f548ed921a2de7c914a8feb3cef9648";

export default node;
